import React from "react";
import bybit from "./../assets/svg/bybit.svg";
import dex from "./../assets/svg/okx-dex.svg";
import htx from "./../assets/svg/htx.svg";
import bitget from "./../assets/svg/bitget.svg";
import poloniex from "./../assets/svg/poloniex.svg";
import lbank from "./../assets/svg/lbank.svg";
import mexc from "./../assets/svg/mexc.svg";
import bitmart from "./../assets/svg/bitmart.svg";
import networkright from "./../assets/png/network-side.png";
function Network() {
  return (
    <>
      <div className="bg-[#F2F4F9] relative">
        {" "}
        <div className="absolute right-0 bottom-0 z-[1] max-w-[120px] md:max-w-[196px]   ">
          <img src={networkright} alt="img" className="w-full" />
        </div>
        <div
          id="Network"
          className="max-w-[1624px] mx-auto px-4 sm:px-6 lg:px-8 my-12 xl:my-20 xl:pt-10 2xl:pt-16 text-center relative z-10"
        >
          <h2
            className="text-black text-3xl sm:text-5xl  xl:text-[70px] 2xl:text-[100px] text-aircruiser xl:tracking-[-2px] text-shadow-2"
            data-aos="fade-up"
          >
            NETWORK
          </h2>
          <p
            className="text-black text-base sm:text-lg xl:text-xl 2xl:text-[24px] leading-[180%] lg:tracking-[0.48px] py-4 md:py-5"
            data-aos="fade-up"
          >
            Josh token will soon be available on all major exchanges
          </p>
          <div className="flex flex-wrap py-4 xl:py-8 gap-4 md:gap-6 xl:gap-8 justify-center  ">
            <div
              className="border border-black bg-white rounded-xl shadow-[0px_6px_0px_0px_#000] max-w-[150px] sm:max-w-[220px] lg:max-w-[270px] 2xl:max-w-[350px] w-full flex flex-col justify-center items-center p-2 sm:p-3 2xl:p-6  "
              data-aos="flip-up"
              data-aos-duration="1000"
            >
              <img
                src={bybit}
                alt="icon"
                className="max-w-[80px] sm:max-w-[120px] xl:max-w-[180px]"
              />
            </div>
            <div
              className="border border-black bg-white rounded-xl shadow-[0px_6px_0px_0px_#000] max-w-[150px] sm:max-w-[220px] lg:max-w-[270px] 2xl:max-w-[350px] w-full flex flex-col justify-center items-center p-2 sm:p-3 2xl:p-6  "
              data-aos="flip-up"
              data-aos-duration="1000"
            >
              <img
                src={dex}
                alt="icon"
                className="max-w-[60px] sm:max-w-[100px] xl:max-w-[143px]"
              />
            </div>
            <div
              className="border border-black bg-white rounded-xl shadow-[0px_6px_0px_0px_#000] max-w-[150px] sm:max-w-[220px] lg:max-w-[270px] 2xl:max-w-[350px] w-full flex flex-col justify-center items-center p-2 sm:p-3 2xl:p-6  "
              data-aos="flip-up"
              data-aos-duration="1000"
            >
              <img
                src={htx}
                alt="icon"
                className="max-w-[80px] sm:max-w-[120px] xl:max-w-[180px]"
              />
            </div>
            <div
              className="border border-black bg-white rounded-xl shadow-[0px_6px_0px_0px_#000] max-w-[150px] sm:max-w-[220px] lg:max-w-[270px] 2xl:max-w-[350px] w-full flex flex-col justify-center items-center p-2 sm:p-3 2xl:p-6  "
              data-aos="flip-up"
              data-aos-duration="1000"
            >
              <img
                src={bitget}
                alt="icon"
                className="max-w-[100px] sm:max-w-[150px] xl:max-w-[225px]"
              />
            </div>
            <div
              className="border border-black bg-white rounded-xl shadow-[0px_6px_0px_0px_#000] max-w-[150px] sm:max-w-[220px] lg:max-w-[270px] 2xl:max-w-[350px] w-full flex flex-col justify-center items-center p-2 sm:p-3 2xl:p-6  "
              data-aos="flip-up"
              data-aos-duration="2000"
            >
              <img
                src={poloniex}
                alt="icon"
                className="max-w-[108px] sm:max-w-[170px] xl:max-w-[236px]"
              />
            </div>
            <div
              className="border border-black bg-white rounded-xl shadow-[0px_6px_0px_0px_#000] max-w-[150px] sm:max-w-[220px] lg:max-w-[270px] 2xl:max-w-[350px] w-full flex flex-col justify-center items-center p-2 sm:p-3 2xl:p-6  "
              data-aos="flip-up"
              data-aos-duration="2000"
            >
              <img
                src={lbank}
                alt="icon"
                className="max-w-[91px] sm:max-w-[150px] xl:max-w-[205px]"
              />
            </div>
            <div
              className="border border-black bg-white rounded-xl shadow-[0px_6px_0px_0px_#000] max-w-[150px] sm:max-w-[220px] lg:max-w-[270px] 2xl:max-w-[350px] w-full flex flex-col justify-center items-center p-2 sm:p-3 2xl:p-6  "
              data-aos="flip-up"
              data-aos-duration="2000"
            >
              <img
                src={mexc}
                alt="icon"
                className="max-w-[130px] sm:max-w-[180px] xl:max-w-[255px]"
              />
            </div>
            <div
              className="border border-black bg-white rounded-xl shadow-[0px_6px_0px_0px_#000] max-w-[150px] sm:max-w-[220px] lg:max-w-[270px] 2xl:max-w-[350px] w-full flex flex-col justify-center items-center p-2 sm:p-3 2xl:p-6  "
              data-aos="flip-up"
              data-aos-duration="2000"
            >
              <img
                src={bitmart}
                alt="icon"
                className="max-w-[130px] sm:max-w-[180px] xl:max-w-[255px]"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Network;
